import { jsx } from "react/jsx-runtime";
import { createContext, useContext, useRef } from "react";
function getController({
  toggleFullscreenHandler = async () => {
  },
  togglePictureInPictureModeHandler = async () => {
  },
  onPlay,
  onPause
} = {}) {
  let play = () => {
    onPlay == null ? void 0 : onPlay();
  };
  let pause = () => {
    onPause == null ? void 0 : onPause();
  };
  let setVolume = () => {
  };
  let setMute = () => {
  };
  let seekTo = () => {
  };
  let enableSubtitles = () => {
  };
  let disableSubtitles = () => {
  };
  let toggleFullscreen = toggleFullscreenHandler;
  let togglePictureInPictureMode = togglePictureInPictureModeHandler;
  const controller = {
    // init action handlers
    play: () => play(),
    pause: () => pause(),
    setVolume: (...args) => setVolume(...args),
    setMute: (...args) => setMute(...args),
    seekTo: (...args) => seekTo(...args),
    enableSubtitles: (...args) => enableSubtitles(...args),
    disableSubtitles: () => disableSubtitles(),
    toggleFullscreen: () => toggleFullscreen(),
    togglePictureInPictureMode: () => togglePictureInPictureMode(),
    // register
    registerPlayHandler: (handler) => {
      play = () => {
        handler();
        onPlay == null ? void 0 : onPlay();
      };
    },
    registerPauseHandler: (handler) => {
      pause = () => {
        handler();
        onPause == null ? void 0 : onPause();
      };
    },
    registerSetVolumeHandler: (handler) => {
      setVolume = handler;
    },
    registerSetMuteHandler: (handler) => {
      setMute = handler;
    },
    registerSeekToHandler: (handler) => {
      seekTo = handler;
    },
    registerEnableSubtitlesHandler: (handler) => {
      enableSubtitles = handler;
    },
    registerDisableSubtitlesHandler: (handler) => {
      disableSubtitles = handler;
    },
    registerToggleFullscreenHandler: (handler) => {
      toggleFullscreen = handler;
    },
    registerTogglePictureInPictureModeHandler: (handler) => {
      togglePictureInPictureMode = handler;
    }
  };
  return controller;
}
const defaultValue =
/** @type {VideoControllerContextType} */
null;

const VideoControllerContext = createContext(
  /** @type {VideoController | null} */
  defaultValue
);
VideoControllerContext.displayName = "VideoControllerContext";
function useVideoController() {
  const videoController = useContext(VideoControllerContext);
  if (!videoController) {
    throw new Error("useVideoController called without a VideoControllerContext.Provider");
  }
  return videoController;
}
function VideoControllerProvider({
  children,
  toggleFullscreenHandler,
  togglePictureInPictureModeHandler
}) {
  const videoControllerRef = useRef(
    getController({ toggleFullscreenHandler, togglePictureInPictureModeHandler })
  );
  return /* @__PURE__ */jsx(VideoControllerContext.Provider, { value: videoControllerRef.current, children });
}
export {
  VideoControllerContext,
  VideoControllerProvider,
  getController,
  useVideoController };
//# sourceMappingURL=dist/components/VideoContextProvider/context/videoController.js.map